export default __webpack_public_path__ + "static/media/panel.ae577253.png";